import { ArticlesVisibilitySettingsBuilder } from '../../common/articles-visibility/articles-visibility-settings.builder';
var OldWidgetSettingsBuilder = /** @class */ (function () {
    function OldWidgetSettingsBuilder() {
        this.widgetSettings = {
            articlesVisibility: new ArticlesVisibilitySettingsBuilder().build(),
            customJsPath: '',
            customCssPath: ''
        };
    }
    OldWidgetSettingsBuilder.prototype.withArticlesVisibility = function (articlesVisibility) {
        this.widgetSettings.articlesVisibility = articlesVisibility;
        return this;
    };
    OldWidgetSettingsBuilder.prototype.withCustomCssPath = function (path) {
        this.widgetSettings.customCssPath = path;
        return this;
    };
    OldWidgetSettingsBuilder.prototype.withCustomJsPath = function (path) {
        this.widgetSettings.customJsPath = path;
        return this;
    };
    OldWidgetSettingsBuilder.prototype.build = function () {
        return this.widgetSettings;
    };
    return OldWidgetSettingsBuilder;
}());
export { OldWidgetSettingsBuilder };
//# sourceMappingURL=old-widget-settings.builder.js.map